import React, { useContext } from 'react';
import styles from './SearchBarPCPSelect.module.scss';
import { AppContext } from '../../../context/AppContext';

const SearchBarPCPSelect = () => {
  const appContext = useContext(AppContext);
 console.log('DEBUG PCP:', appContext.search.pcp);


  const handlePCPChange = (value: string | null) => {
    appContext.updatePCP(value);
  };

  return (
   <div className={styles.pcpSelectContainer}>
  <select
    className={styles.pcpSelect}
    value={appContext.search.pcp || ''}
    onChange={(e) => {
      const value = e.target.value;
       console.log('Selected value:', value); 
      handlePCPChange(value === '' ? null : value);
    }}
  >
    <option value="">All Results</option>
    <option value="Yes">PCP Only</option>
    <option value="No">Non-PCP Providers</option>
  </select>
</div>
  );
};

export default SearchBarPCPSelect;